 <template>
  <div id="performance" v-touch:swipe="swipeHandler">
    <!-- <scenary-options></scenary-options> -->
    <Navbar></Navbar>
    <report-header
      	:pageNumberIndicator="pageNumberIndicator"
      	:backOption="false"
      	:title="componentsData.headerTitle"
    ></report-header>
    <div class="performance_content"
    	:style="{
				'background': colors.theme == 'dark' ? `linear-gradient(180deg, ${colors[colors.theme].from} 0%,  ${colors[colors.theme].to} 100%)` : '#fff',
				'color': colors.theme == 'dark' ? '#fff' : '#000',
			}
    ">
      <div class="mean_hits">
        	<div class="mean_info">
          		<h1
                :style="{
                  'color': colors.secondary,
                }"
              >{{ $t("views.report.performance.mean_info.span1") }}
            		<strong
                  :style="{
				            'color': colors.theme == 'dark' ? '#fff':'#000',
			            }">{{ $t("views.report.performance.mean_info.strong1") }}</strong>
          		</h1>
        	</div>
        <div class="circle_graphic">
          <circle-chart></circle-chart>
        </div>
        <div class="scenary" v-if="!wsWithoutGlobal.includes(workspaceId)">
          <h2
            :style="{
              'color': colors.theme == 'dark' ? '#7c848b':'#737373',
            }
          ">{{ $t("views.performance.scenary") }} 
            <strong
            :style="{
              'color': colors.theme == 'dark' ? '#7c848b':'#737373',
            }
            ">{{ $t("views.performance.strong1") }}:</strong>
          </h2>
          <span
          :style="{
              'color': colors.theme == 'dark' ? '#7c848b':'#737373',
            }
          ">
            71
            <small>%</small>
          </span>
        </div>
        <report-pagination
          :activeBefore="pagination.activeBefore"
          :activeNext="pagination.activeNext"
          :nextRoutePagination="pagination.nextRoutePagination"
          :beforeRoutePagination="pagination.beforeRoutePagination"
        ></report-pagination>
      </div>

      <div class="others_means"        :style="{
          'border-top': colors.theme == 'dark' ? '1px solid #364149' : '1px solid #ccc'
        }">
        <div class="minutes">
          <div>
            <Clock class="report-svg-icon"></Clock>
            <h3>
              <strong>{{$t("views.report.performance.others_means.h3.strong1")}}</strong>
              {{ $t("views.report.performance.others_means.h3.span1") }}
            </h3>
          </div>
          <div class="vertical_bars">
            <div class="vertical_bar">
              <bar-chart
                :color="colors.secondary"
                :value="(Math.round(reportData.performance.elapsedTimeHit))"
                :singleBar="true"
              ></bar-chart>
              <span
                :style="{color: `${colors.secondary}`}"
                class="hint_per_minute_value"
              >{{Math.round(reportData.performance.elapsedTimeHit)}}</span>              
            </div>
            <div class="vertical_bar" v-if="!wsWithoutGlobal.includes(workspaceId)">
              <bar-chart color="#cccccc" value="4" :singleBar="true"></bar-chart>
              <span class="hint_per_minute_value" :style="{color: '#60656e'}">4</span>
            </div>
          </div>          
        </div>
        <div class="hints_to_hit"
        :style="{
          'border-left': colors.theme == 'dark' ? '1px solid #364149' : '1px solid #ccc',
          'border-right': colors.theme == 'dark' ? '1px solid #364149' : '1px solid #ccc'
        }">
          <div>
            <Plus class="report-svg-icon"></Plus>
            <h3>
              <strong>{{ $t("views.report.performance.hints_to_hit.strong1") }}</strong>
              {{ $t("views.report.performance.hints_to_hit.span1") }}
            </h3>
          </div>
          <div class="vertical_bars">
            <div class="vertical_bar">
              <bar-chart
                :color="colors.secondary"
                :value="Math.round(reportData.performance.hintHit)"
                :singleBar="true"
              ></bar-chart>
              <span
                :style="{color: `${colors.secondary}`}"
                class="hint_per_minute_value"
              >{{Math.round(reportData.performance.hintHit)}}</span>              
            </div>
            <div class="vertical_bar" v-if="!wsWithoutGlobal.includes(workspaceId)">
              <bar-chart color="#cccccc" value="5" :singleBar="true"></bar-chart>
              <span class="hint_per_minute_value" :style="{color: '#60656e'}">5</span>
            </div>
          </div>
        </div>
        <div class="attempts_to_hit">
          <div>
            <HitAndMissed class="report-svg-icon"></HitAndMissed>
            <h3>
              <strong>{{ $t("views.report.performance.attempts_to_hit.strong1") }}</strong>
              {{ $t("views.report.performance.attempts_to_hit.span1") }}
            </h3>
          </div>
          <div class="vertical_bars">
            <div class="vertical_bar">
              <bar-chart
                :color="colors.secondary"
                :value="Math.round(reportData.performance.attemptHit)"
                :singleBar="true"
              ></bar-chart>
              <span
                :style="{color: `${colors.secondary}`}"
                class="hint_per_minute_value"
              >{{Math.round(reportData.performance.attemptHit)}}</span>              
            </div>
            <div class="vertical_bar" v-if="!wsWithoutGlobal.includes(workspaceId)">
              <bar-chart color="#cccccc" value="4" :singleBar="true"></bar-chart>
              <span class="hint_per_minute_value" :style="{color: '#60656e'}">4</span>
            </div>
          </div>           
        </div>
      </div>
      <div class="color-label"
      :style="{
        background: colors.theme == 'dark' ? '#000' : '#f0f0f0'  
      }">
        <div class="piece" :style="{background: colors.secondary}"></div>
        <span class="label-you" :style="{color: colors.secondary}">{{$t("views.report.performance.hints_info_you")}}</span>
        <div class="piece" :style="{background: '#858585'}"></div>
        <span :style="{color: '#858585'}">{{ $t("views.performance.strong1") }}</span>
      </div>
    </div>
    <!-- <button-next :title="componentsData.buttonNextTitle" nextRoute="graphic"></button-next> -->
  </div>
</template>

<script>
import Header from "../../components/shared/report/Header";
import ScenaryOptions from "../../components/shared/report/ScenaryOptions";
import ReportPagination from "../../components/shared/report/ReportPagination";
import PieChart from "../../components/shared/report/charts/PieChart";
import CircleChart from "../../components/shared/report/charts/CircleChart";
import BarChart from "../../components/shared/report/charts/BarChart";
import VueApexCharts from "vue-apexcharts";
import Navbar from "../../components/shared/header/Navbar";
import Clock from "../../components/shared/customIcons/report/Clock.vue"
import Plus from "../../components/shared/customIcons/report/Plus.vue"
import HitAndMissed from "../../components/shared/customIcons/report/HitAndMissed.vue"
export default {
  name: "Performance",
  props: [],
  components: {
    Navbar,
    "report-header": Header,
    "report-pagination": ReportPagination,
    "scenary-options": ScenaryOptions,
    apexchart: VueApexCharts,
    "pie-chart": PieChart,
    "circle-chart": CircleChart,
    "bar-chart": BarChart,
    Clock, HitAndMissed, Plus
  },
  data() {
    return {
      reportData: JSON.parse(localStorage.getItem("report")),
      componentsData: {
        headerTitle: "Performance",
        buttonNextTitle: this.$t(
          "views.report.performance.componentsData.buttonNextTitle"
        ),
        backText: this.$t("views.report.performance.componentsData.backText"),
      },
      chartOptions: {
        series: [58, 81],
        labels: this.$t("views.report.performance.chartOptions.labels"),
        hollow: {
          background: "black",
          margin: 0,
        },
        track: {
          margin: 0,
          background: "#83037D",
        },
        plotOptions: {
          radialBar: {
            dataLabels: {
              show: true,
              name: {
                show: false,
              },
              total: {
                show: true,
                fontSize: "43px",
                fontFamily: "Exo, sans-serif",
              },
            },
          },
        },
      },
      pagination: {
        activeBefore: false,
        activeNext: true,
        beforeRoutePagination: false,
        nextRoutePagination: "graphic",
      },
      pageNumberIndicator: 1,
	  colors: {},
	  workspaceId: '',
	  wsWithoutGlobal: ["eBHsVn7mliHvdn7HpQ2w"]
    };
  },
  created() {
    this.colors = JSON.parse(localStorage.getItem("colors"));
    // console.log("Report: ", this.reportData);
    this.workspaceId = this.reportData.workspaceId
    // console.log("pageNumberIndicator Performance: ", this.pageNumberIndicator);
  },
  methods: {
    swipeHandler(direction) {
      if (direction == "left")
        this.$router.push(this.pagination.nextRoutePagination);
    },
  },
};
</script>

<style lang="scss">
#performance {
  	position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
}

.performance_content {
  display: flex;
  flex-direction: column;
  height: calc(100% - 103px);

  .mean_hits {
    align-items: center;
    display: flex;
    flex: 1;
    justify-content: start;

    .mean_info,
    .circle_graphic,
    .scenary {
      width: 33.33%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .mean_info {
    justify-content: flex-end !important;

    h1 {
      text-align: center;
      letter-spacing: 2px;
      text-transform: uppercase;
      display: flex;
      flex-direction: column;
      font-size: 32px;
      font-weight: 900;
    }
    strong {
      font-weight: 500;
      font-size: 12px;
    }
  }

  .scenary {
    font-weight: 900;
    justify-content: flex-start;
    flex-direction: column;
    align-items: flex-start !important;

    h2 {
      text-transform: uppercase;
      display: flex;
      flex-direction: column;
      font-size: 14px;
      margin: 0 30px 3px 0;
      text-align: center;
      font-weight: 500;
      font-size: 12px;
      letter-spacing: 1px;      

      strong{
        font-size: 15px;
        font-weight: 900;
        padding: 7px 0 0 0;
      }
    }

    span {
      font-size: 45px;
      padding: 0 0 0 19px;
      font-weight: 600;

      small {
        font-size: 15px;
        padding: 12px 0 0 0;
      }
    }
  }

  .others_means {
    height: 45vh;
    border-top: 1px solid #364149;

    .report-svg-icon{
      margin: 0 auto;
      display: flex;
      justify-content: center;
      svg{
        width: 70px;
        max-height: 45px;
        position: relative;
        // top: 10px;
      }
    }
    
  }

  .color-label{
    display: flex;
    background: #000;
    height: 5vh;
    justify-content: center;
    align-items: center;   
    
    .piece{
      width: 50px;
      height: 10px;
      border-radius: 20px;
      margin-right: 5px; 
    }
    span{
      text-transform: capitalize;
    }
    .label-you{
        margin-right:  25px;
    }
  }

  .circle_graphic {
    #SvgjsText1234 {
      font-size: 31px;
      // font-family: "Exo", sans-serif !important;
      font-weight: 700;
    }
  }
  .others_means {
    display: flex;
      .vertical_bars {
        display: flex;
        height: 100%;
        padding-top: 20px;

        .vertical_bar {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin: 0 15px;

          .bar-chart {
            background-color: #fff;
            padding: 8px;
            // min-height: 100px;
            display: flex;
            flex-direction: column-reverse;
          }

          span {
            font-size: 32px;
            font-weight: 700;
            padding: 10px 0;
          }

          .hints_info {
            transform: rotate(-90deg);
            font-size: 15px;
            font-weight: 700;
            position: absolute;
            letter-spacing: 2px;
          }

          .hints_info_you {
            margin: 193px 0px 0 -35px;
          }

          .hints_info_scenary {
            margin: 180px 0px 0 35px;
          }
        }
      }
    .minutes,
    .hints_to_hit,
    .attempts_to_hit {
      width: 33.33%;
      padding-top: 15px;
    }
    .minutes {
      // background-color: rgba($color: #02f0e4, $alpha: 0.3);
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: center;

      h3 {
        letter-spacing: 1px;
        text-transform: uppercase;
        display: flex;
        flex-direction: column;
        font-size: 22px;
        text-align: center;
        // margin: 0 0 15px 0;

        strong {
          font-weight: 900;
          font-size: 18px;
        }
      }
      .pie_info {
        span {
          transform: rotate(-90deg);
          font-size: 17px;
          font-weight: 700;
          letter-spacing: 2px;
          position: absolute;
        }

        .pie_info_you {
          color: #83037d;
          margin: 60px 0px 0 -38px;
        }
        .pie_info_scenary {
          color: rgba($color: #2f353a, $alpha: 0.3);
          margin: 65px 0px 0 -52px;
        }
      }

      .pie_chart {
        background: url(/img/icons/chronometer_bg.png) no-repeat;
        background-size: cover;
        width: 115px;
        height: 132px;

        .pie_value {
          z-index: 9;
          position: absolute;
          margin: 50px 0 0 -72px;
          color: #fff;
          font-size: 52px;
          transform: none;
        }
      }
    }
    .hints_to_hit {
      border-left: 1px solid #364149;
      border-right: 1px solid #364149;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: center;

      h3 {
        letter-spacing: 1px;
        text-transform: uppercase;
        display: flex;
        flex-direction: column;
        font-size: 22px;
        text-align: center;
        // margin: 0 0 15px 0;

        strong {
          font-weight: 900;
          font-size: 18px;
        }
      }

    }

    .attempts_to_hit {
      // background-color: rgba($color: #02f0e4, $alpha: 0.3);
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: center;

      // span {
      //   position: absolute;
      //   z-index: 9;
      //   color: #fff;
      //   font-weight: 700;
      //   font-size: 45px;
      //   &:nth-child(2) {
      //     margin: -55px 0px 0 75px;
      //   }
      //   &:nth-child(3) {
      //     margin: 110px 0px 0 80px;
      //   }
      //   &:nth-child(4) {
      //     margin: -10px 0 0 0;
      //   }
      //   &:nth-child(5) {
      //     margin: 100px 0 0 0;
      //   }
      // }

      h3 {
        letter-spacing: 1px;
        text-transform: uppercase;
        display: flex;
        flex-direction: column;
        font-size: 22px;
        text-align: center;
        // margin: 0 0 15px 0;

        strong {
          font-weight: 900;
          font-size: 18px;
        }
      }

      .hints_info {
        transform: rotate(-90deg);
        font-size: 15px;
        font-weight: 700;
        position: absolute;
        letter-spacing: 2px;
      }

      .attempts_info_you {
        margin: 5px 0px 0 30px;
      }

      .attempts_info_scenary {
        margin: 70px 0px 0 32px;
      }  

      .minutes_to_hit {
        background-color: #fff;
        padding: 15px;
        // min-height: 100px;
        display: flex;
        flex-direction: column;

        // .bar-chart{
        //     position: relative;
        //     top: 10px;
        // }
      }
    }
  }
}

@media only screen and (min-width: 900px) {
  // #performance .performance_content .others_means .minutes, .performance_content .others_means .hints_to_hit, .performance_content .others_means .attempts_to_hit{
  //   padding: 85px 0;
  // }
}

@media only screen and (max-width: 600px) {
  #performance {
    .performance_content {
      .mean_hits {
        .mean_info {
          padding-right: 32px;

          // h1 {
          //   font-size: 20px;
          // }
        }
        .scenary {
          padding-left: 32px;
        }
      }

      .others_means {
        h3 {
          font-size: 17px;
        }

        
        .vertical_bars {
          .vertical_bar {
            margin: 5px;
          }
        }
      

        .minutes {
          .pie_info {
            .pie_chart {
              width: 101px;
              height: 114px;

              .pie {
                width: 83px;
                margin: 21px 7px;
              }
              .pie_value {
                margin: 45px 0 0 -60px;
                font-size: 40px;
              }
            }
          }
        }

        // .attempts_to_hit {
        //   span {
        //     &:nth-child(2) {
        //       margin: -55px 0px 0 60px;
        //     }
        //     &:nth-child(3) {
        //       margin: 110px 0px 0 60px;
        //     }
        //   }
        // }
      }
    }
  }
}

@media only screen and (max-width: 500px) {
  #performance {
    .performance_content {
      .mean_hits {
        .mean_info {
          padding-right: 32px;

          // h1 {
          //   font-size: 20px;
          // }
        }
        .scenary {
          padding-left: 32px;
        }
      }

      .others_means {
        h3 {
          font-size: 12px;
        }

        .minutes {
          // justify-content: space-around;

          .pie_info {
            .pie_info_you {
              margin: 36px 0px 0 -38px;
            }
            .pie_info_scenary {
              margin: 40px 0px 0 -52px;
            }

            .pie_chart {
              width: 80px;
              height: 90px;

              .pie {
                width: 65px;
                margin: 16px 6px;
              }
              .pie_value {
                margin: 37px 0 0 -48px;
                font-size: 30px;
              }
            }
          }
        }

        .hints_to_hit {
          .vertical_bars {
            .vertical_bar {
              .hints_info_scenary {
                margin: 149px 0px 0 35px;
              }
              .hints_info_you {
                margin: 163px 0px 0 -35px;
              }

              .bar-chart {
                // height: 150px;
              }
            }
          }
        }
        .attempts_to_hit {
          .attempts_to_hit_value {
            font-size: 30px;
          }

          .minutes_to_hit {
            padding: 10px;
          }

          // span {
          //   &:nth-child(2) {
          //     margin: -40px 0px 0 55px;
          //   }
          //   &:nth-child(3) {
          //     margin: 78px 0px 0 55px;
          //   }
          //   &:nth-child(4) {
          //     margin: -10px 0 0 0;
          //   }
          //   &:nth-child(5) {
          //     margin: 80px 0 0 0;
          //   }
          // }
        }
      }
    }
  }
}
@media only screen and (max-width: 430px) {
  #performance {
    .performance_content {
      .mean_hits {
        .mean_info {
          padding-right: 32px;

          // h1 {
          //   font-size: 16px;
          // }
        }
        .scenary {
          padding-left: 32px;

          h2 {
            font-size: 10px;
          }

          span {
            font-size: 50px;
          }
        }
      }

      .others_means {
        h3 {
          font-size: 12px;
        }

        .minutes {
          justify-content: space-around;

          .pie_info {
            .pie_info_you {
              margin: 36px 0px 0 -33px;
            }
            .pie_info_scenary {
              margin: 40px 0px 0 -42px;
            }

            .pie_chart {
              width: 80px;
              height: 90px;

              .pie {
                width: 65px;
                margin: 16px 6px;
              }
              .pie_value {
                margin: 37px 0 0 -48px;
                font-size: 30px;
              }
            }
          }
        }

        .hints_to_hit {
          justify-content: space-around;

          .vertical_bars {
            .vertical_bar {
              .hints_info_scenary {
                margin: 143px 0px 0 28px;
              }
              .hints_info_you {
                margin: 155px 0px 0 -28px;
              }

              .bar-chart {
                // height: 150px;
                padding: 5px;
              }
            }
          }
        }
        .attempts_to_hit {
          justify-content: space-around;

          .attempts_to_hit_value {
            font-size: 30px;
          }

          .minutes_to_hit {
            padding: 7px;
          }

          // span {
          //   &:nth-child(2) {
          //     margin: -40px 0px 0 50px;
          //   }
          //   &:nth-child(3) {
          //     margin: 78px 0px 0 50px;
          //   }
          //   &:nth-child(4) {
          //     margin: -10px 0 0 0;
          //   }
          //   &:nth-child(5) {
          //     margin: 90px 0 0 0;
          //   }
          // }
        }
      }
    }
  }
}
@media only screen and (max-width: 360px) {
  #performance {
    .performance_content {
      .mean_hits {
        .mean_info {
          padding-right: 32px;

          // h1 {
          //   font-size: 12px;
          // }
        }
        .scenary {
          padding-left: 32px;

          h2 {
            font-size: 8px;
          }

          span {
            font-size: 37px;
          }
        }
      }

      .others_means {
        h3 {
          font-size: 9px;
        }

        .minutes {
          justify-content: space-around;

          .pie_info {
            .pie_info_you {
              letter-spacing: 1px;
              margin: 30px 0px 0 -25px;
              font-size: 13px;
            }
            .pie_info_scenary {
              letter-spacing: 1px;
              margin: 30px 0px 0 -32px;
              font-size: 13px;
            }

            .pie_chart {
              width: 60px;
              height: 70px;

              .pie {
                width: 49px;
                margin: 13px 5px;
              }
              .pie_value {
                margin: 29px 0 0 -37px;
                font-size: 23px;
              }
            }
          }
        }
        .bar-chart {
          // height: 150px;
          padding: 5px;
        }
        span {
          font-size: 23px;
        }
        .hints_to_hit {
          justify-content: space-around;

          .vertical_bars {
            .vertical_bar {
              // span {
              //   font-size: 23px;
              // }

              .hints_info_scenary {
                margin: 143px 0px 0 28px;
                font-size: 13px;
              }
              .hints_info_you {
                margin: 155px 0px 0 -28px;
                font-size: 13px;
              }

              // .bar-chart {
              //   height: 150px;
              //   padding: 5px;
              // }
            }
          }
        }
        .attempts_to_hit {
          justify-content: space-around;

          .attempts_to_hit_value {
            font-size: 23px;
          }

          .minutes_to_hit {
            padding: 7px;
          }

          // span {
          //   &:nth-child(2) {
          //     margin: -60px 0px 0 70px;
          //     font-size: 13px;
          //   }
          //   &:nth-child(3) {
          //     margin: 69px 0px 0 35px;
          //     font-size: 13px;
          //   }
          //   &:nth-child(4) {
          //     margin: -25px 0 0 0;
          //   }
          //   &:nth-child(5) {
          //     margin: 65px 0 0 0;
          //   }
          // }
			.attempts_to_hit_value_you.without_scenary {
				font-size: 40px;
				margin: 72px 0px 0 0px;
			}			  
        }
      }
    }
  }
}
@media only screen and (max-width: 380px) and (max-height: 625px) {
  #performance {
    .performance_content {
      .others_means {
        // .attempts_to_hit {
        //   span {
        //     &:nth-child(5) {
        //       margin: 75px 0 0 0;
        //     }
        //     &:nth-child(3) {
        //       margin: 70px 0px 0 45px;
        //     }
        //     &:nth-child(2) {
        //       margin: -40px 0px 0 45px;
        //     }
        //   }
        // }
      }
    }
  }
}
@media only screen and (min-width: 360px) and (max-height: 565px) {
  #performance {
    .performance_content {
      .hints_to_hit {
        .vertical_bars {
          .vertical_bar {
            .hints_info_scenary {
              margin: 132px 0px 0 28px !important;
            }
            .hints_info_you {
              margin: 140px 0px 0 -28px !important;
            }
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 320px) {
  #performance {
    .performance_content {
      .others_means {
        // .attempts_to_hit {
        //   span {
        //     &:nth-child(2) {
        //       margin: -28px 0px 0 35px;
        //     }
        //     &:nth-child(3) {
        //       margin: 57px 0 0 35px;
        //     }
        //     &:nth-child(4) {
        //       margin: -15px 0 0 0;
        //     }
        //   }

        //   .minutes_to_hit {
        //     margin: 20px 0 0 0;
        //     padding: 5px;
        //   }
        // }
        h3 strong{
          font-size: 13px;
        }
        .minutes, .hints_to_hit, .attempts_to_hit{
          padding-top: 10px;
        }
        .hints_to_hit {
          .vertical_bars {
            .vertical_bar {
              .bar-chart {
                height: 100px;
              }

              .hints_info_you {
                margin: 107px 0px 0 -22px;
              }
              .hints_info_scenary {
                margin: 95px 0px 0 19px;
              }
            }
          }
        }
      }
      .mean_hits {
        .mean_info {
          padding-right: 30px;
          padding-left: 10px;
        }
      }
    }
  }
}
@media only screen and (max-height: 667px) and (max-width: 375px) {
  #performance {
    .performance_content {
      .others_means {
        .minutes {
          .pie_info {
            span {
              font-size: 14px;
            }

            .pie_chart {
              width: 55px;
              height: 65px;

              .pie {
                width: 44px;
                margin: 13px 5px;
              }

              .pie_value {
                margin: 26px 0px 0 -34px;
                font-size: 21px;
              }
            }
          }
        }
      }
      .hints_to_hit {
        .vertical_bars {
          .vertical_bar {
            .hints_info_scenary {
              margin: 155px 0px 0 28px !important;
            }
            .hints_info_you {
              margin: 162px 0px 0 -28px !important;
            }
          }
        }
      }
    }
  }
}
@media only screen and (min-width: 501px) {
  #performance {
    .performance_content {
      .mean_hits {
        .mean_info {
          // h1 {
          //   font-size: 20px;
          // }
        }
      }
      .others_means {
        .minutes {
          h3 {
            font-size: 15px;
          }
          .pie_info {
            .pie_chart {
              width: 90px;
              height: 107px;
              .pie {
                width: 75px;
              }

              .pie_value {
                margin: 44px 0 0 -58px;
                color: #fff;
                font-size: 40px;
              }
            }
          }
        }
      }
      .hints_to_hit {
        h3 {
          font-size: 15px;
        }
        // .bar-chart {
        //   height: 160px;
        // }
        .hints_info_you {
          margin: 186px 0px 0 -35px;
        }
        .hint_per_minute_value {
          font-size: 25px;
        }
      }
      .attempts_to_hit {
        font-size: 40px;
        h3 {
          font-size: 15px;
        }
        // .attempts_to_hit_value_you {
        //   margin: -18px 0 0 0;
        // }
        // .attempts_to_hit_value {
        //   margin: 85px 0 0 0;
        // }
      }
    }
  }
}
</style>
